import {Component, Input, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {ActivityLogDialogComponent} from './dialog-activity-log/activity-log-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import {ActivityLogService, ActivityLogView, ActivityTypeEnum, ActionTypeEnum} from "../../api";


@Component({
    selector: 'app-activity-log',
    templateUrl: 'activity-log.component.html',
    standalone: false
})

export class ActivityLogComponent implements OnInit {
  @Input()
  set resourceId(id: number) {
    this._resourceId = id;
   // this.refresh();
  }
  @Input()
  set activityType(type: ActivityTypeEnum) {
    this._activityType = type;
    //this.refresh();
  }
  @Input() limit = 1;
  @Input() inDialog = false;

  public _resourceId?: number;
  public _activityType?: ActivityTypeEnum;
  public isLoading = true;

  public activities: Array<ActivityLogView> = [];

  constructor(private activityLogService: ActivityLogService,
               private dialog: MatDialog,
               private translate: TranslateService ) {
  }

  ngOnInit() {

    this.refresh();
  }

  public refresh() {
    this.isLoading = true;

    if (this._activityType && this._resourceId) {
      this.activityLogService.getUserActivityLogs(this._activityType, this._resourceId, this.limit, 0).subscribe((resp) => {
        this.activities = resp;
        this.isLoading = false;
      });
    }
  }

  loadMore() {
    this.isLoading = true;
    if (this._activityType && this._resourceId) {
      this.activityLogService.getUserActivityLogs(this._activityType, this._resourceId, this.limit, this.activities.length).subscribe((resp) => {
        this.activities.push(...resp);
        this.isLoading = false;
      });
    }
  }

  userName(a: ActivityLogView): string {
    return `${a.Firstname || ''} ${a.Middlename || ''} ${a.Lastname || ''}`.replace('  ', ' ').trim();
  }

  getActionIcon(a: ActivityLogView): string {
    if (a.ActionTypeId === ActionTypeEnum.Create.toString()) {
      return 'far fa-plus-square';
    } else if (a.ActionTypeId === ActionTypeEnum.Delete.toString()) {
      return 'far fa-trash-alt';
    }
    return 'far fa-edit';
  }

  getActionDescription(a: ActivityLogView): string {
    if (!a.ActivityTypeId) {
      return '';
    }

    const activityTypeDict = a.ActivityTypeId;
    if (!activityTypeDict) {
      return '';
    }

    const activityArticle = this.translate.instant('ACTIVITY.LOG.ARTICLE.' + a.ActivityTypeId.toUpperCase());
    const activityName = this.translate.instant('ACTIVITY.LOG.NAME.' + a.ActivityTypeId.toUpperCase());

    if (a.ActionTypeId) {
      return this.translate.instant('ACTIVITY.ACTION.ENUM.' + a.ActionTypeId.toUpperCase(), {resource : (activityArticle + ' ' + activityName)});
    }
    return `${activityArticle} ${activityName} ` + this.translate.instant('ACTIVITY.LOG.CHANGED');
  }

  public showHistory() {
    this.dialog.open(ActivityLogDialogComponent, {
      width: '720px',
      disableClose: true,
      data: {title: this.translate.instant('ACTIVITY.LOG.DIALOG.TITLE'), resourceId: this._resourceId, activityType: this._activityType}
    });
  }
}
